import React from "react";

/**
 * Value shape for {@link CustomRenderCell}.
 *
 * The escape hatch for interactive cells: the page owns the element, the table
 * keeps its search, sorting, and pagination chrome. Sortable columns using this
 * type must set `subKey: "sortValue"` on their header so the comparator has a
 * scalar to work with.
 */
export interface CustomRenderCellValue {
  /** Renders the cell body. */
  render: () => React.ReactNode;
  /** Scalar the shared comparator sorts on. */
  sortValue?: string;
}

interface CustomRenderCellProps {
  value: CustomRenderCellValue;
}

/**
 * Renders a caller-supplied element, isolated from the row click handler.
 *
 * @param props - Cell value carrying the render function
 * @returns The caller's element
 */
export const CustomRenderCell: React.FC<CustomRenderCellProps> = ({
  value,
}) => {
  if (typeof value?.render !== "function") {
    return null;
  }
  return (
    <div
      className="table-cell-custom-render"
      onClick={(event) => event.stopPropagation()}
    >
      {value.render()}
    </div>
  );
};

export default CustomRenderCell;
